// O PERÍODO DAS TELAS DE DIAGNÓSTICO.
//
// "Meu e-mail chegou?" e "Não recebi um e-mail" são as duas metades da mesma
// pergunta — uma olha o que saiu, a outra o que entrou. Elas abriam com
// períodos diferentes: 7 dias numa, 30 na outra.
//
// Isso não é detalhe de enfeite: quem procura uma mensagem e não acha vai da
// primeira para a segunda, e a janela muda embaixo dele sem avisar. A
// mensagem de ontem aparece num lado e some do outro.
//
// E `desdeQuando` estava escrita duas vezes, uma em cada arquivo — que é
// justamente como os dois padrões divergiram.

/**
 * Quantos dias as telas de diagnóstico olham para trás.
 *
 * 30 e não 7: quem abre essas telas está atrás de uma mensagem que não
 * achou, e "não está aqui" com janela de uma semana não responde nada —
 * manda a pessoa mexer no filtro antes de saber se vale a pena.
 */
export const DIAS_PADRAO = 30;

/** O começo da janela, em ISO, para mandar ao servidor. */
export function desdeQuando(dias: number): string {
  const d = new Date();
  d.setDate(d.getDate() - dias);
  return d.toISOString();
}
